import React from 'react';
import moment from "moment";

import Currency from '../../Currency';
import Icon from "../../Icon";
import Image from "../../Image";

import getDateFormat from "../../../utils/DateFormatRetriever";

import IntlMessage from '../../../LocaleEngine';

import "./index.scss";

export default function Cart(props){
    const { index, item } = props;

    return (
        <div className="cartItem">
            <div key={"item"+index} className="product">
                <div className="multimedia">
                    {
                        item.product.product_image ?
                        <Image source={item.product.product_image} alt={item.product.name}/>    
                        :
                        null
                    }
                </div>
                <div className="content">
                    <div className="supplierName">{item.product.supplier_name}</div>
                    <div className="productName">{item.product.name}</div>
                    <div className="date"><span><IntlMessage id="cart.labels.arrival_date" />: </span>{moment.utc(item.product.searchData.arrivalDate).format(getDateFormat())}</div>
                    <div className="date"><span><IntlMessage id="cart.labels.departure_date" />: </span>{moment.utc(item.product.searchData.departureDate).format(getDateFormat())}</div>
                </div>
                <div className="sideinfo">
                    <div className="price">
                        <Currency float={true} value={item.total / 100}/>
                    </div>
                    <div onClick={() => props.deleteItem(item, true)} className="remove">
                        <Icon size={16} icon={"feather-trash-2"} />
                        <span><IntlMessage id="cart.remove_item.buttons.remove" /></span>
                    </div>
                </div>
            </div>
        </div>
    )
}
